import React, { useState, useEffect } from 'react';
import { FaComments, FaPencilRuler, FaMoneyBillWave, FaProjectDiagram, FaTools, FaCheckCircle } from "react-icons/fa";
import "./waywework.css";
import Popupboxx from '../popupboxx/Popupboxx';

function Waywework() {
  const [activeStep, setActiveStep] = useState(1);
    const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((prevStep) => (prevStep === 6 ? 1 : prevStep + 1));
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const stepContent = [
    {
      label: "Consultation",
      description: "We begin by discussing your vision and requirements, either online or in person, to ensure we fully understand your needs.",
      icon: <FaComments />
    },
    {
      label: "Design",
      description: "Our team creates a custom interior design plan, including 3D renders and layout options, tailored to your preferences.",
      icon: <FaPencilRuler />
    },
    {
      label: "Budget",
      description: "We provide clear pricing and a well-defined scope of work to ensure the project stays within your budget and meets expectations.",
      icon: <FaMoneyBillWave />
    },
    {
      label: "Planning",
      description: "We source high-quality materials and carefully plan the project timeline to ensure smooth execution.",
      icon: <FaProjectDiagram />
    },
    {
      label: "Execution",
      description: "Our skilled team manages the project, ensuring precise implementation with quality checks at every stage.",
      icon: <FaTools />
    },
    {
      label: "Handover",
      description: "Your completed space is delivered on time, with every detail perfected and your full satisfaction guaranteed.",
      icon: <FaCheckCircle />
    }
  ];

  return (
    <>


      <section className="section-wework">
        <div className="container container-wework">
          <div className="main-wework-section">
            <section style={{ marginTop: "50px", marginBottom: "20px" }}>
              <div className='heading-head'>
                <h3 className='heading-h3' >The Way We Work</h3>
                {/* <div className="underline-oueclient"></div> */}
              </div>

            </section>
            {/* <h2 className="heading-head">The Way We Work</h2> */}
            <p className="subHeading-para">Six simple steps to transform your space with ease.</p>

            <div className="div-weworksub">
              <ul className="wework-ul">
                {stepContent.map((step, index) => (
                  <li key={index} className={activeStep === index + 1 ? "active-wework" : ""}>
                    <span className="step-icon">{step.icon}</span>
                    <label>{step.label}</label>
                  </li>
                ))}
              </ul>
            </div>

            {/* Active step details */}
            <div className="label-activestep">
              <label className='d-flex align-items-center justify-content-center'
              style={{ textTransform:"uppercase"}}>{stepContent[activeStep - 1].label}</label>
              <span>{stepContent[activeStep - 1].description}</span>
            </div>

             <br />

            <div className="d-flex align-items-center justify-content-center" >
              <button className="download-btn" onClick={() => setIsPopupOpen(true)}>
                Get Details
              </button>
            </div>
          </div>
        </div>
      </section>
     
       <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
    </>
  );
}

export default Waywework;
